import CreditsVoidModal from './CreditsVoidModal';
import { connect } from 'react-redux';

import { creditsActions } from 'src/store/modules/credits';

const mapDispatchToProps = (dispatch: any) => ({
  voidCredit: (databaseId: number, note: string) => {
    dispatch(creditsActions.voidCredit(databaseId, note));
  }
});

export const pureComponent = CreditsVoidModal;

export default connect(null, mapDispatchToProps)(CreditsVoidModal);
